import Home from "./pages/Home"
import Container from "react-bootstrap/Container"
import "./App.css";

function App() {
  return (
   
      <Home/>
  
  )
}

export default App
